export const knowty = {
    title: "Knowty",
    description: "An educational page for tenth grade students.  Created with the purpose of help students in their academic process.",
    technologies: ["HTML", "CSS", "Javascript", "React", "Bootstrap"],
    img: "knowty.png",
    link: "https://knowty.netlify.app/"
}

export const happySpace = {
    title: "Happy space",
    description: "A page to relax and have fun looking at pictures and gifs of cats and dogs.",
    technologies: ["HTML", "CSS", "Javascript", "React", "Tailwind"],
    img: "happySpace.png",
    link: "https://happyspace.netlify.app/"
}

export const morseTranslator = {
    title: "Morse translator",
    description: "A page to descifrate morse messages or encode them.",
    technologies: ["HTML", "CSS", "Javascript", "React", "Next JS", "Tailwind"],
    img: "morseTranslator.png",
    link: "https://morsec-translator.netlify.app/"
}
